import api from './axios';

export const getAnomalies      = (params)      => api.get('/anomalies', { params });
export const getAnomalySummary = ()            => api.get('/anomalies/summary');
export const getAnomalyChecks  = ()            => api.get('/anomalies/checks');
export const ignoreAnomaly     = (id, note)    => api.post(`/anomalies/${id}/ignore`, { note });
export const reopenAnomaly     = (id)          => api.post(`/anomalies/${id}/reopen`);
export const scanAnomalies     = (check)       => api.post('/anomalies/scan', check ? { check } : {});
